// Exports
export default {
	"modal": "modal_XPJE-",
	"modalContent": "modalContent_LHg90",
	"qr": "qr_KjWBs",
	"qrText": "qrText_a32g2",
	"closeButton": "closeButton_u45l5"
};
